/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons401,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsDocumentRejectionReasons.ts";

function getGetApiV1PersonIdAttachmentsDocumentRejectionReasonsUrl(
  id: GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/attachments/document-rejection-reasons` as const,
  };
  return res;
}

/**
 * @description Lista os motivos de rejeição ativos para uso no fluxo de rejeição do anexo. **(Requer Authorization para autenticação)**
 * @summary Motivos de rejeição de documento (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/document-rejection-reasons}
 */
export async function getApiV1PersonIdAttachmentsDocumentRejectionReasons(
  id: GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsDocumentRejectionReasons401
      | GetApiV1PersonIdAttachmentsDocumentRejectionReasons500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdAttachmentsDocumentRejectionReasonsUrl(
      id,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
